import { Component, EventEmitter, OnInit, Output } from "@angular/core";

export type MonthYearData = {
    isValid: boolean,
    monthValue: number,
    yearValue: number,
    error: {},
}

@Component({
    selector: 'app-month-year-selects',
    template: require('./month-year-selects.component.html')
})
export class MonthYearSelectsComponent implements OnInit{

    @Output() modelChange = new EventEmitter<MonthYearData>()

    static readonly GENERIC_VALIDATION_ERROR = "Please select a valid expiration date."

    localMonthYearData: MonthYearData = {} as MonthYearData;
    currentDate = new Date();
    monthArray: number[];
    yearArray: number[];

    constructor() {

        this.monthArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

        this.yearArray = new Array(11)
            .fill(this.currentDate.getFullYear())
            .map((currentYear, index) => currentYear + index);

        this.localMonthYearData.isValid = true;
    }

    ngOnInit() {
        this.localMonthYearData.monthValue = -1;
        this.localMonthYearData.yearValue = -1;
    }

    updateValues() {
        const currentMonth = this.currentDate.getMonth() + 1;
        const currentYear = this.currentDate.getFullYear();
        if(this.localMonthYearData.monthValue < 0 || this.localMonthYearData.monthValue < 0) {
            this.localMonthYearData.error =
                { errors: [{ message: MonthYearSelectsComponent.GENERIC_VALIDATION_ERROR, label: 'card-exp-required' }] };
            this.localMonthYearData.isValid = false;
        } else if (this.localMonthYearData.yearValue < currentYear ||
            (this.localMonthYearData.yearValue === currentYear && this.localMonthYearData.monthValue < currentMonth)) {
            this.localMonthYearData.error =
                { errors: [{ message: MonthYearSelectsComponent.GENERIC_VALIDATION_ERROR, label: 'card-exp-required' }] };
            this.localMonthYearData.isValid = false;
        }else {
            this.localMonthYearData.error = {};
            this.localMonthYearData.isValid = true;
        }

        this.modelChange.emit(this.localMonthYearData);

    }

    formatMonth(month: number) {
        return month < 10 ? '0' + month : month.toString();
    }

    setValues(month: number, year: number) {
        this.localMonthYearData.monthValue = month;
        this.localMonthYearData.yearValue = year;
    }
}

